module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3 body-border-right",
    attrs: {
      "md5": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  }), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "go-to-settings-page": "/",
      "include-delete-single": true,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('button', {
          staticClass: "button-transparent",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.showRooms(props.row.rooms, props.row.name, props.row.quantity)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('button', {
          staticClass: "button-transparent",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.showRooms(props.row.rooms, props.row.name, props.row.quantity)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.row.quantity) + "\n\t\t\t\t\t\t")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "md7": ""
    }
  }, [_c('v-layout', {
    staticClass: "body-border-bottom",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mb-3",
    attrs: {
      "md6": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Habitación'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, [(_vm.roomsQuantity) ? _c('h3', {
    staticClass: "semibold-blue-title-20"
  }, [_vm._v(_vm._s(_vm.roomTypeName) + " - " + _vm._s(_vm.roomsQuantity))]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('room-number-list', {
      key: room.id,
      attrs: {
        "link": ("/rooms/" + (room.id)),
        "room": room
      }
    })
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00705f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/OtherEnviroments.vue
// module id = 724
// module chunks = 108